import 'antd/lib/button/style';
import 'antd/lib/input/style';
import 'antd/lib/message/style';
import 'antd/lib/icon/style';
import 'antd/lib/checkbox/style';

import '../VtxSearchMap.less';